import React from "react"

function IconStopwatch({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="stopwatch"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-stopwatch"
      {...props}
    >
      <path
        d="M12.052 5.024c2.22 0 4.234.878 5.715 2.307l.869-.867a.818.818 0 0 1 1.236 1.065l-.08.092-.961.963a8.233 8.233 0 1 1-6.78-3.56zm0 1.309a6.924 6.924 0 1 0 0 13.849 6.924 6.924 0 0 0 0-13.849zm.047 2.411c.414 0 .757.308.81.708l.008.11v3.79a.818.818 0 0 1-1.629.111l-.007-.11v-3.79c0-.452.366-.819.818-.819zm1.847-6.252a.818.818 0 0 1 .111 1.629l-.11.007h-3.79a.818.818 0 0 1-.111-1.629l.11-.007h3.79z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconStopwatch
